var React = require('react');

function CompanyLocation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0H10V2.12602C9.68038 2.04375 9.3453 2 9 2H6V3.35418C5.37764 4.05931 5 4.98555 5 6C5 6.70872 5.25451 7.48662 5.5496 8.17517C5.85537 8.88862 6.25508 9.61878 6.64251 10.2645C7.0318 10.9133 7.41947 11.4947 7.70906 11.913L7.76953 12H0V0ZM2 2H4V4H2V2ZM4 6H2V8H4V6Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 12C9 12 12 8 12 6C12 4.34315 10.6569 3 9 3C7.34315 3 6 4.34315 6 6C6 8 9 12 9 12ZM9 7C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5C8.44772 5 8 5.44772 8 6C8 6.55228 8.44772 7 9 7Z","fill":"currentColor","key":1})]);
}

CompanyLocation.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CompanyLocation;

CompanyLocation.default = CompanyLocation;
